(function($) {
  $('.hamburger-container').click( function() {
    $('.hamburger').toggleClass('active');
    $('.menu-hauptmenue-container').toggleClass('active');
  });
})(jQuery);


/* Verwenden Sie Ihre Tracking-ID, wie oben beschrieben. */
var gaProperty = 'UA-23800643-12';  
/* Deaktiviere das Tracking, wenn das Opt-out cookie vorhanden ist. */
 var disableStr = 'ga-disable-' + gaProperty; if (document.cookie.indexOf(disableStr + '=true') > -1) {  window[disableStr] = true; }
  /* Die eigentliche Opt-out Funktion.  */
function gaOptout(){  
  document.cookie = disableStr + '=true; expires=Thu, 31 Dec 2099 23:59:59 UTC; path=/';  
  window[disableStr] = true; 
  alert('Google Analytics Tracking deaktiviert.');
}
